/**
 * Purpose:
 *   Exposes shared session account/user identifiers for client-side scoping.
 *
 * Notes:
 *   Client-only. Subscribes to sessionAccountStore (one /api/auth/session fetch).
 */

'use client';

import { useCallback, useSyncExternalStore } from 'react';

import {
  getServerSessionAccountSnapshot,
  getSessionAccountSnapshot,
  reloadSessionAccount,
  subscribeSessionAccount,
  type SessionAccountSnapshot,
} from './sessionAccountStore';

export type SessionAccountState = Omit<SessionAccountSnapshot, never>;

export function useSessionAccount(): SessionAccountState & { reload: () => void } {
  const state = useSyncExternalStore(
    subscribeSessionAccount,
    getSessionAccountSnapshot,
    getServerSessionAccountSnapshot
  );

  const reload = useCallback(() => {
    void reloadSessionAccount();
  }, []);

  return {
    ...state,
    reload,
  };
}